export const HSE_CATEGORIES_ORIGIN = 'hse-categories'
export const HSE_PRIORITIES_ORIGIN = 'hse-priorities'
export const HSE_LIST_TABLE_CONFIG_KEY = 'HSE_LIST_TABLE_CONFIG'

export const OPEN_STATUS = 0
export const CLOSED_STATUS = 1
export const EXPIRED_STATUS = 2

export const HSE_RISK_STATUS = {
  OPEN_STATUS,
  CLOSED_STATUS,
  EXPIRED_STATUS,
}
